import { render } from "./TutorFAQs.vue?vue&type=template&id=5d601cb0"
import script from "./TutorFAQs.vue?vue&type=script&lang=js"
export * from "./TutorFAQs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__